export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/4a3dbbaeebd81c970f39dfd9033ad55f.png";